/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  Card,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/src/components/shad/card";

import EmptyUser from "@assets/blank-user.webp";
import { toast } from "sonner";
import { useEffect, useRef, useState } from "react";
import { Loader } from "@mantine/core";
import api from "@/src/utils";
import apiRoutes from "@/src/apiRoutes";
import { isEmpty } from "lodash";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useAppDispatch, useAppSelector } from "@/src/app/hooks";
import { authenticate } from "@/src/features/userSlice";
import { useTranslation } from "react-i18next";
// import { Camera } from "lucide-react";

const FILE_UPLOAD_LIMIT_MB = 10;

const ProfileImage = ({ profile }: { profile: any }) => {
  const { t } = useTranslation();
  const trans = (key: string) => t(`app.settings.profile.image.${key}`);
  const { user } = useAppSelector((state) => state.user);
  const inputFile = useRef<any>(null);
  const [file, setFile] = useState<string>();
  const [imageUrl, setImageUrl] = useState<string>("");

  const dispatch = useAppDispatch();
  const queryClient = useQueryClient();
  const handleImageChange = async (e: any) => {
    if (e.target.files[0].size > FILE_UPLOAD_LIMIT_MB * 1024 * 1024) {
      toast.warning(
        `You can upload a photo of maximum size of ${FILE_UPLOAD_LIMIT_MB} MB`
      );
    } else {
      if (e.target.files[0].type?.includes("svg")) {
        alert("Sorry, You cannot upload svg files");
      } else {
        const file = e.target.files[0];
        const fileReader = new FileReader();
        fileReader.readAsDataURL(file);
        fileReader.onloadend = () => {
          const base64String = fileReader.result?.toString().split(",")[1];
          setFile(base64String);
        };
        // upload(file, "pimage", profile?.image);
      }
    }
  };

  const uploadImage = async (image: string) => {
    const res = await api.post(apiRoutes.settings, {
      type: "profile_image",
      image,
    });
    return res.data;
  };

  const { mutate, isLoading } = useMutation({
    mutationFn: uploadImage,
    onSuccess: (data) => {
      if (data?.success) {
        toast.success("Profile photo updated successfully");
        queryClient.invalidateQueries({ queryKey: ["get_first_paint"] });
        dispatch(authenticate({ ...user, image: imageUrl }));
        setImageUrl("");
        setFile("");
      } else {
        toast.warning(data?.info);
      }
    },
  });

  useEffect(() => {
    if (!isEmpty(file)) {
      api
        .post(apiRoutes.imageUpload, {
          path: "profile",
          images: [file],
        })
        .then((res) => {
          if (res.data?.success) {
            mutate(res.data?.info[0]);
            setImageUrl(res.data?.info[0]);
          }
        })
        .catch(() => {
          toast.error("Something went wrong");
        })
        .finally(() => {
          inputFile.current.value = null;
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [file]);

  return (
    <Card>
      <CardHeader>
        <CardTitle>{trans("title")}</CardTitle>
        <div>
          <div className="flex items-center justify-between gap-4">
            <div>
              <CardDescription>{trans("desc")}</CardDescription>
              <CardDescription>{trans("desc2")}</CardDescription>
            </div>
            <div>
              {!isLoading ? (
                <div className="relative">
                  <img
                    onClick={() => inputFile.current.click()}
                    className="md:h-20 h-14 md:w-20 w-20 rounded-full cursor-pointer"
                    src={profile?.image ?? EmptyUser}
                    alt="Profile "
                  />
                  <input
                    accept="image/*"
                    type="file"
                    id="file"
                    ref={inputFile}
                    style={{ display: "none" }}
                    onChange={handleImageChange}
                  />
                  {/* <Camera className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-8 h-8 text-gray-500 rounded-full" /> */}
                </div>
              ) : (
                <div className="h-10 w-10 rounded-full">
                  <Loader color="blue" size={"md"} />
                </div>
              )}
            </div>
          </div>
        </div>
      </CardHeader>
    </Card>
  );
};

export default ProfileImage;
